import { Directive, ElementRef, HostListener, Injector, Input, runInInjectionContext } from '@angular/core';
import { MatTooltip, TooltipPosition } from '@angular/material/tooltip';

@Directive({
  selector: '[sgTextOverflowTooltip]',
  standalone: true,
  host: {
    class: 'sg-text-ellipsis',
  },
})
export class SgTextOverflowTooltipDirective {
  @Input('sgTextOverflowTooltip') tooltipMessage: string;
  @Input() position: TooltipPosition;
  @Input() tooltipClass: string | string[] | Set<string> | { [key: string]: any };
  @Input() showDelay: number;
  @Input() hideDelay: number;

  private toolTip: MatTooltip | undefined;

  constructor(
    private injector: Injector,
    private el: ElementRef
  ) {}

  @HostListener('mouseenter', ['$event.target'])
  onMouseEnter(target: EventTarget | null) {
    if (!target) return;
    const element = target as HTMLElement;
    const isTooltipEnabled = element.scrollWidth > element.offsetWidth;
    if (isTooltipEnabled && !this.toolTip) {
      this.createTooltip();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.toolTip) {
      this.destroyTooltip();
    }
  }

  private createTooltip(): void {
    runInInjectionContext(this.injector, () => {
      this.toolTip = new MatTooltip();
    });
    this.toolTip.message = this.tooltipMessage;
    if (this.position) {
      this.toolTip.position = this.position;
    }
    if (this.tooltipClass) {
      this.toolTip.tooltipClass = this.tooltipClass;
    }
    if (this.showDelay >= 0) {
      this.toolTip.showDelay = this.showDelay;
    }
    if (this.hideDelay >= 0) {
      this.toolTip.hideDelay = this.hideDelay;
    }
    this.toolTip.show();
  }

  private destroyTooltip(): void {
    this.toolTip.hide();
    this.toolTip.ngOnDestroy();
    this.toolTip = undefined;
  }
}
